import { createInertiaApp } from '@inertiajs/react'
import { router } from '@inertiajs/react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { createElement } from 'react'

import { initTooltips } from '../utils/tooltips'

const appEl = document.getElementById('app')
if (appEl && appEl.dataset.page) {
createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })
    return pages[`../pages/${name}.jsx`]
  },
  setup({ el, App, props }) {
    if (el.hasChildNodes()) {
      hydrateRoot(el, createElement(App, props))
      queueMicrotask(() => initTooltips(document))
      return
    }

    createRoot(el).render(createElement(App, props))
    queueMicrotask(() => initTooltips(document))
  },
})

router.on('finish', () => {
  initTooltips(document)
})
}
